export var replaceSpaces = function replaceSpaces(s) {
  var replacement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '_';
  return s.replaceAll(' ', replacement);
};